<template>
    <div class="action-sheet-container">
        <div
            @click.self="close"
            class="action-sheet-overlay"
            :class="{ 'is-active': modelValue }"
        ></div>

        <div
            class="action-sheet"
            @click.self="close"
            :class="{
                'is-active': modelValue,
                'position-center': position === 'center' && isDesktop,
            }"
        >
            <div class="drag-indicator bg-primary-300"></div>
            <div class="action-sheet-header p25 pb0" v-if="title">
                <h3
                    class="action-sheet-title text-neutral-900 foint-weight-bold title-xsmall d-flex justify-content-between align-items-center pb25 mb25 border0 bb1 border-neutral-300"
                >
                    <span>{{ title }}</span>
                    <button
                        @click="close"
                        class="close btn btn-sm p0 m0 border0 border0-hover text-neutral-500 text-neutral-600-hover"
                    >
                        <i class="bx bx-x title-small"></i>
                    </button>
                </h3>
            </div>
            <div class="action-sheet-content px25 pb25">
                <slot></slot>
            </div>
            <div
                class="action-sheet-footer p25 border0 bt1 border-neutral-300"
                v-if="$slots.footer"
            >
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null,
        },
        position: {
            type: String,
            default: "auto",
            validator: (value) => ["auto", "center"].includes(value),
        },
    },
    data() {
        return {
            isDesktop: window.innerWidth >= 768,
        }
    },
    methods: {
        close() {
            this.$emit("update:modelValue", false)
        },
        handleResize() {
            this.isDesktop = window.innerWidth >= 768
        },
    },
    mounted() {
        window.addEventListener("resize", this.handleResize)
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize)
    },
}
</script>

<style scoped lang="scss">
.action-sheet-container {
    --transition-duration: 0.2s;
    --desktop-max-width: 425px;

    .action-sheet-overlay {
        position: fixed;
        inset: 0;
        background-color: rgba(0, 0, 0, 0.4);
        width: 100vw;
        height: 100vh;
        transition: var(--transition-duration) ease-in;
        transition-property: opacity;
        opacity: 0;
        z-index: 100;
        left: -100vw;
        top: 0;

        &.is-active {
            opacity: 1;
            left: 0;
        }
    }

    .action-sheet {
        z-index: 101;
        width: 100%;
        background-color: #fff;
        position: fixed;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        max-height: calc(100vh - 32px);

        @media (min-width: 768px) {
            max-width: var(--desktop-max-width);
            border-radius: 16px;
            top: 16px;

            &.position-center {
                --desktop-max-width: 597px;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                right: auto;
                display: none;
                &.is-active {
                    right: auto;
                    display: flex;
                }
            }

            &:not(.position-center) {
                right: calc(var(--desktop-max-width) * -1);
                transition: right var(--transition-duration) ease-in-out;
                &.is-active {
                    right: 16px;
                }
            }
        }

        @media (max-width: 767px) {
            width: 100%;
            max-width: 100%;
            left: 0;
            border-radius: 16px 16px 0 0;
            height: auto;
            max-height: 70vh;
            bottom: -100%;
            transition: bottom var(--transition-duration) ease-in-out;
            display: flex;
            flex-direction: column;

            &.is-active {
                bottom: 0;
            }

            .drag-indicator {
                width: 42px;
                height: 2px;
                margin: auto;
                background-color: #a0a0ab;
                border-radius: 8px;
                position: relative;
                top: -20px;
            }
        }

        .action-sheet-content {
            overflow-y: auto;
        }

        .action-sheet-footer {
            box-shadow: 0px -2px 16px 0px #2a2e330f;
        }
    }
}
</style>
